const experiences = [
	{
		id: 1,
		date: "2018 - 2019",
		nom: "IT-Start",
		entreprise: "IMIE",
		poste: "Formation",
		redirection: "https://google.com/search?q=imie+nantes",
		description:
			"Apprentissage général dans le domaine du numérique. Découverte du développement, de l'administration réseau et du web design.",
		competences: [
			"HTML5",
			"CSS3",
			"SASS",
			"JavaScript",
			"Node.js",
			"Express.js",
		],
	},
	{
		id: 2,
		date: "2020 - 2021",
		nom: "Développeur Web",
		entreprise: "OpenClassrooms",
		poste: "Formation",
		redirection: "https://openclassrooms.com/",
		description:
			"Apprentissage des langages HTML/CSS coté front-end ainsi que de JavaScript en FullStack. 7 projets effectués en autonomie. Obtention d'une certification RNCP de niveau 5 correspondant à un niveau bac+2.",
		liens: [
			{
				nom: "Formation",
				lien: "https://openclassrooms.com/fr/paths/185-developpeur-web",
			},
			{
				nom: "Projets",
				lien: "https://github.com/CedricOlivry/Formation-Developpeur-Web",
			},
		],
		competences: [
			"HTML5",
			"CSS3",
			"SASS",
			"JavaScript",
			"Node.js",
			"Express.js",
		],
	},
	{
		id: 3,
		date: "2021 - 2023",
		nom: "Développeur d'applications JavaScript React",
		entreprise: "OpenClassrooms",
		poste: "Formation",
		redirection: "https://openclassrooms.com/",
		description:
			"Apprentissage de la librairie React et approfondissement des connaissances en JavaScript coté front-end. 14 projets effectués en autonomie. Obtention d'une certification RNCP de niveau 6 correspondant à un niveau bac+3/4.",
		liens: [
			{
				nom: "Formation",
				lien: "https://openclassrooms.com/fr/paths/516-developpeur-dapplication-javascript-react",
			},
			{
				nom: "Projets",
				lien: "https://github.com/CedricOlivry/Formation-Developpeur-JavaScript-React",
			},
		],
		competences: ["React.js", "Redux", "JavaScript", "TypeScript"],
	},
	{
		id: 4,
		date: "2025",
		nom: "Développeur Next.JS & Tailwind CSS",
		entreprise: "Believemy",
		poste: "Formation",
		redirection: "https://believemy.com/",
		description:
			"Apprentissage des frameworks Next.JS et Tailwind CSS. Approfondissement des connaissances en React. Obtention d'un certificat d'achèvement.",
		liens: [
			{
				nom: "Formation Next.JS",
				lien: "https://believemy.com/fr/formations/formation-nextjs",
			},
			{
				nom: "Formation Tailwind.CSS",
				lien: "https://believemy.com/fr/formations/formation-tailwindcss",
			},
		],
		competences: ["Next.JS", "Tailwind CSS", "JavaScript"],
	},
];

export default experiences;
